<template>
  <div class="component">
    <div class="component-title" style="margin-bottom: 8px;">二次费用</div>
    <table style="margin-bottom: 4px;">
      <tbody>
        <tr style="height: 64px;">
          <td width="23%" style="font-size: 14px;font-weight: bold;font-family: DIN-Medium;">高速费</td>
          <td width="77%" style="font-size: 12px;">凭票据收</td>
        </tr>
        <tr style="height: 64px;">
          <td width="23%" style="font-size: 14px;font-weight: bold;font-family: DIN-Medium;">停车费</td>
          <td width="77%" style="font-size: 12px;">凭票据收</td>
        </tr>
        <tr style="height: 90px;">
          <td width="23%" style="font-size: 14px;font-weight: bold;font-family: DIN-Medium;">等候费</td>
          <td width="77%">
            <tr style="display: flex;">
              <td style="flex: 1;font-size: 12px;line-height: 32px;">不超过{{ carAttributeFeeConfig.loadUnloadFreeMinuteTime || 0 }}分钟</td>
              <td style="flex: 1;font-size: 12px;line-height: 32px;">超过{{ carAttributeFeeConfig.loadUnloadFreeMinuteTime || 0 }}分钟</td>
              <td style="flex: 1;font-size: 12px;line-height: 32px;">封顶</td>
            </tr>
            <tr style="display: flex;">
              <td style="flex: 1;font-size: 12px;line-height: 58px;color: #EC892E;">免费</td>
              <td style="flex: 1;font-size: 12px;">
                <span style="line-height: 20px;">按每分钟{{ carAttributeFeeConfig.loadUnloadWaitMinuteFee ? carAttributeFeeConfig.loadUnloadWaitMinuteFee : "0" }}元收费</span>
                <span style="color: #C9C2BB;line-height: 20px;">（不足1分钟按1分钟计算）</span>
              </td>
              <td style="flex: 1;font-size: 12px;line-height: 58px;">{{ $zeroPadding(carAttributeFeeConfig.maxLoadUnloadWaitFee) }}元</td>
            </tr>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="display: flex;">
      <div style="width: 6px;height: 6px;border-radius: 50%;overflow: hidden;background-color: #EC892E;margin-right: 4px;flex-shrink: 0;margin-top: 6px;"></div>
      <div style="font-size: 12px;line-height: 20px;">等候时长：合计每个装卸点，从司机到达，至装卸货完成离开的时间（包括排队、装卸、等待文件处理等）</div>
    </div>
  </div>
</template>

<script>
export default {
  name:"SecondaryFee",
  props:["carAttributeFeeConfig"],
}
</script>

<style scoped lang="scss">
 table,
  th,
  td {
    border: 1px solid #C9C2BB;
  }

  table {
    width: 100%;
    margin: 0 auto;
    display: table;
    border-spacing: 0;
    border-radius: 4px;
    overflow: hidden;
  }
  th,
  td {
    border-top-width: 0;
    border-left-width: 0;
    text-align: center;
  }

  th:last-child,
  td:last-child {
    border-right-width: 0;
  }

  tr:last-child td {
    border-bottom-width: 0;
  }

  td tr td{
    border-top: 1px solid #C9C2BB;
  }
  td tr:first-child td {
    border-top: 0;
    border-bottom: 0;
  }
  table tbody > tr > td:first-child {
    background-color: #F8F8F8;
  }
</style>